import { ThrowError } from './errors';

/**
 * Checks if a number is within a specified range.
 * @param value - The number to check.
 * @param min - The minimum value of the range.
 * @param max - The maximum value of the range.
 * @returns `true` if the number is within range; otherwise, `false`.
 */
export const isInRange = (value: number, min: number, max: number): boolean => {
  if (min > max) {
    ThrowError(`min (${min}) couldn't be bigger than max (${max})`);
  }

  return value >= min && value <= max;
};

/**
 * Restricts a number to be within a specified range.
 * @param value - The number to restrict.
 * @param min - The minimum allowed value.
 * @param max - The maximum allowed value. Defaults to `Infinity`.
 * @returns The number restricted to the specified range.
 */
export const getNumberInRange = (value: number, min: number, max: number = Infinity): number => {
  let trunkNumber = value;

  if (min > max) {
    ThrowError(`min (${min}) couldn't be bigger than max (${max})`);
  }

  if (trunkNumber < min) {
    trunkNumber = min;
  } else if (trunkNumber > max) {
    trunkNumber = max;
  }

  return trunkNumber;
};

const siSymbolList = ['', 'K', 'M', 'B', 'T', 'Qa', 'Qi'];
export const abbreviateNumber = (value: string | number) => {
  const int = parseInt(typeof value === 'string' ? value : value.toString(10), 10);
  const tier = Math.floor(Math.log10(int || 1) / 3);

  const scaled = (int / 1000 ** tier).toFixed(1).replace(/\.0+$/, '');

  return `${scaled}${siSymbolList[tier]}`;
};
